import { createApolloClient } from './apollo';

const apolloClient = createApolloClient();

export default apolloClient;
